import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from "@angular/core";
import { DisplaySanbox } from "../../shared/sandbox/providers/display.sandbox";
import { GlobalSandbox } from "../../shared/sandbox/providers/global.sandbox";
import { takeUntil, take } from "rxjs/operators";
import { Subject } from "rxjs";
import { jsPDF } from 'jspdf';
import html2canvas from "html2canvas";

@Component({
  selector: "bioseal-display",
  templateUrl: "./display.component.html",
  styleUrls: ["./display.component.css"],
  providers: [DisplaySanbox],
})
export class DisplayComponent implements OnInit {

  constructor(public displaySandbox: DisplaySanbox, public globalSandbox: GlobalSandbox) {

    this.displaySandbox.init()

  }

  isLoading: boolean = true;
  isFinished: Subject<boolean> = new Subject<boolean>();

  @Output() nextEvent = new EventEmitter<boolean>();
  @Output() previousEvent = new EventEmitter<boolean>();

  @ViewChild('eventDoc', { static: false }) eventDoc: ElementRef;


  ngOnInit(): void {
    new Promise((resolve, reject) => {
      this.displaySandbox
        .getBioseal()
        .pipe(take(1))
        .subscribe(
          (res) => {
            resolve(res);
            this.isFinished.next(true);
          },
          (err) => resolve(err)
        );
    });

    this.globalSandbox.isBarcodeDataMatrix().pipe(take(1)).subscribe(
      (res) => {
        if (res) {
          this.displaySandbox.initBarcode();
        }
      }
    );

  }

  public downloadPdf() {

    const passWidth = this.eventDoc.nativeElement.clientWidth * 0.026;
    const passHeight = this.eventDoc.nativeElement.clientHeight * 0.026;
    const posX = (21 - passWidth) / 2;
    const posY = (29.7 - passHeight) / 2;

    const docHtml = this.eventDoc.nativeElement;
    html2canvas(docHtml, {
      scale: 3
    }).then(
      (canvas) => {
        const contentDataURL = canvas.toDataURL('image/png');
        const pdf = new jsPDF({
          orientation: 'p',
          unit: 'cm',
          format: 'a4'
        });
        pdf.addImage(contentDataURL, 'PNG', posX, posY, passWidth, passHeight);
        pdf.save('event-doc.pdf');
        this.displaySandbox.saveFile();
      }
    );



  }

  ngOnDestroy(): void {
    this.isFinished.complete();
  }

  previous(): void {
    this.previousEvent.emit();
  }
}
